import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async createDriverDetail (context, { accountId, driverDetail }) {
    const path = `accounts/${accountId}/driverdetails`
    const response = await ApiServer.post(path, driverDetail)
    return response.data
  },

  async fetchDriverDetail (_, { accountId, driverDetailId }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}`
    const response = await ApiServer.get(path)
    return response.data
  },

  async createDriversLicense (context, { accountId, driverDetailId, license }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/driverslicenses`
    const response = await ApiServer.post(path, license)
    return response.data
  },

  async updateDriversLicense (context, { accountId, driverDetailId, licenseId, license }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/driverslicenses/${licenseId}`
    const response = await ApiServer.put(path, license)
    return response.data
  },

  async deleteDriversLicense (context, { accountId, driverDetailId, licenseId }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/driverslicenses/${licenseId}`
    const response = await ApiServer.delete(path)
    return response.data
  },

  async updateDriverDetail (context, { accountId, driverDetailId, driverDetail }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}`
    const response = await ApiServer.put(path, driverDetail)
    return response.data
  },

  async createTrailerIdentifier (context, { accountId, driverDetailId, trailerIdentifier }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/traileridentifiers`
    const response = await ApiServer.post(path, trailerIdentifier)
    return response.data
  },

  async updateTrailerIdentifier (context, { accountId, driverDetailId, trailerIdentifierId, trailerIdentifier }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/traileridentifiers/${trailerIdentifierId}`
    const response = await ApiServer.put(path, trailerIdentifier)
    return response.data
  },

  async deleteTrailerIdentifier (context, { accountId, driverDetailId, trailerIdentifierId }) {
    const path = `accounts/${accountId}/driverdetails/${driverDetailId}/traileridentifiers/${trailerIdentifierId}`
    const response = await ApiServer.delete(path)
    return response.data
  }
}
